import AntIcon from '@expo/vector-icons/AntDesign';
import React from 'react';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';
import { AppColors } from 'src/themes/Colors';
import { iconSize, metrics } from 'src/themes/Metrics';
import styled from 'styled-components/native';

import { Container } from './Container';
import { RegularText } from './RegularText';
import { SizedBox } from './SizedBox';

const Styled = {
  OuterWrapper: styled.View``,
  Wrapper: styled(TouchableOpacity)`
    height: ${metrics.inputHeight}px;
    padding: ${metrics.medium}px;
    padding-bottom: ${metrics.small}px;
    border-radius: ${metrics.borderRadius}px;
  `,
  // border-width: ${StyleSheet.hairlineWidth}px;
  // border-color: ${AppColors.border};
};

interface Props {
  labelLang?: string;
  value: any;
  onChange(data: any): void;
  placeholderLang?: string;
  onPress?(): void;
  clearValue?: number | string | null;
  clearButton?: boolean;
  iconLeft?: any;
  labelWrapperStyle?: StyleProp<ViewStyle>;
  row?: boolean;
  // isRequire?: boolean;
  disabled?: boolean;
  errorMessage?: string;
}
export const NewButtonInput = ({
  value = '',
  labelWrapperStyle = null,
  iconLeft = null,
  onChange = () => {},
  onPress = () => {},
  labelLang,
  placeholderLang,
  row,
  clearButton,
  // isRequire,
  disabled,
  errorMessage,
  clearValue = '',
}: Props) => {
  return (
    <Styled.OuterWrapper style={row ? { flex: 1 } : { width: '100%' }}>
      <TouchableOpacity
        disabled={disabled}
        activeOpacity={0.8}
        style={{
          flexDirection: 'row',
          height: metrics.inputHeight,
          width: '100%',
          alignItems: 'center',
        }}
        onPress={onPress}>
        {iconLeft}
        <Container marginLeft={metrics.large} flex>
          {!value ? (
            <RegularText fontSize="large" color={AppColors.gray} style={labelWrapperStyle} textLang={placeholderLang} />
          ) : (
            <>
              <RegularText color={AppColors.gray} fontSize="medium" style={labelWrapperStyle} textLang={labelLang} />
              <SizedBox height={metrics.tiny} />
              <RegularText>{value}</RegularText>
            </>
          )}
          {errorMessage && (
            <RegularText textAlign="left" color={AppColors.red} fontSize="small">
              {errorMessage}
            </RegularText>
          )}
        </Container>
        {clearButton && value ? (
          <TouchableOpacity
            onPress={() => onChange(clearValue)}
            style={{ alignItems: 'center', justifyContent: 'center' }}
            hitSlop={{ top: 10, right: 10, bottom: 5, left: 10 }}>
            <AntIcon name="close" size={iconSize.medium} color="#707070" />
          </TouchableOpacity>
        ) : (
          <View />
        )}
      </TouchableOpacity>
    </Styled.OuterWrapper>
  );
};
